import Vue from 'vue';
import { SbwOperationConstant, CreateTypeConstant, ServiceCodeConstant } from './Constants';

const SbwPopHelper = {};


/**
 * 内容默认居中显示，改为靠左显示
 * @return {{style: string}}
 */
const getClass = () => ({ style: 'text-align: left; word-break: break-all' });

export function operations(caseOps, target, params, type, disabled) {
	switch (parseInt(caseOps, 10)) {
		// 续费操作
		case SbwOperationConstant.RENEW: {
			Ajax.get({
				url: '/api/order',
				action: '/submitRenew',
				param: {
					region: params.region,
					resourceId: params.bandwidthPackageId,
					serviceCode: ServiceCodeConstant.CPSBW
				},
				success: (data) => {
					if (type !== 'detail') {
						target.updateList('refresh');
					}
					window.location.href = `${Vue.prototype.Config.RENEW_CONSOLE_URL}/orderConfirmPageIp?requestId=${data.tmpOrderId}&resourceType=${ServiceCodeConstant.CPSBW}`;
				},
			});
			break;
		}
		// 移出共享带宽
		case SbwOperationConstant.REMOVESHARED: {
			const h = target.$createElement;
			const param = {
				region: params.region,
				bandwidthPackageId: params.bandwidthPackageId,
				elasticIpId: params.elasticIpId
			};
			target.$msgbox({
				title: target.$t('sbw.text.removeShareBandWidthEip'),
				message:h('div',null, [
                                    h('div',{
                    'class':'i-text'
                },[
                    h('div',
                        {
                            'class': 'tip-warning mb20',
                            'style':'line-height: 20px; text-align: left',
                            'domProps': {
                                innerHTML: target.$t('eip.text.removeShareBandwidthTip', [params.realBandwidth, params.realExtraUplinkBandwidth])

                            }

                        },
                    )
                    ]),
	                h('p', getClass(), [
	                    h('span', null, target.$t('eip.help.confirmToUnshare', [params.elasticIp, params.bandwidthPackageName])),
	                ])

                ]),
				closeOnClickModal: false,
				showCancelButton: true,
				confirmButtonText: target.$t('popHelper.text.sure'),
				cancelButtonText: target.$t('popHelper.text.cancel'),
			}).then(() => {
				Ajax.put('/api/cps/removeBandwidthPackageIp', param)
				.then(() => {
					if (type === 'list') {
						target.updateList('refresh');
					} else if (type === 'detail') {
						target.getSourceData();
						target.getEipList();
					}
				})
				.catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						target.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				})
				.finally(() => {
				});
			});
			break;
		}
		default:
		break;
	}
}

export default SbwPopHelper;



// WEBPACK FOOTER //
// ./src/common/SbwPopHelper.js